exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "label{\n  text-align:left\n}\nlegend{\n    margin-top: 40px;\n}   \nform{\n   margin-bottom: 40px; \n}\n\n/* Common styles for all types */\n.bs-callout {\n  padding: 20px;\n  margin: 20px 0;\n  border: 1px solid #eee;\n  border-left-width: 5px;\n  border-radius: 3px;\n}\n.bs-callout h4,  {\n  margin-top: 0;\n}\n\n.bs-callout h4, .bs-callout h5 {\n  margin-bottom: 5px;\n}\n.bs-callout p:last-child {\n  margin-bottom: 0;\n}\n\n.bs-callout code {\n  border-radius: 3px;\n}\n\n.bs-callout-info {\n  border-left-color: #1b809e;\n}\n.bs-callout-danger {\n  border-left-color: #d9534f;\n}\n.bs-callout h4 {\n  color: #333;\n}\n\n.bs-callout-info h5 {\n  color: #1b809e;\n}\n\n.label-2review {\n        background-color: #86608c;\n}\n.label-escalated {\n    background-color: #d67017;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/grant-form/grant-form.component.css
// module id = 851
// module chunks = 1